import * as React from 'react';
import { ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './KPSelectableList.css'

class KPSelectableListItem extends React.PureComponent<ISelectableListItem, any> {
    constructor(props) {
        super(props);
        
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect() {
        let id = this.props.id;
        let selected = !this.props.selected;

        if (this.props.handleSelect) {
            this.props.handleSelect(id, selected);
        }
    }

    public render() {
        let selector: any =
            <div className="col-4 input-container allign-center">
                <div className={"cursor-pointer ssp-selectable-list-item-selector " + (this.props.className ?? "") + (this.props.selectOnLeft ? " left-align" : "") + (this.props.selected ? " selected" : "")}>
                </div>
            </div>;

        return (
            <div className={"cursor-pointer row ssp-selectable-list-item" + (this.props.disabled ? " disabled" : "")} onClick={this.handleSelect}>
                {this.props.selectOnLeft && selector}
                <div className="col-8 ssp-selectable-list-item-description">{this.props.label}</div>
                {!this.props.selectOnLeft && selector}
            </div>
        );
    }
}

export default KPSelectableListItem